module.exports = __webpack_public_path__ + "img/transnistria.64456833.svg";